<template>
  <form @submit.prevent="confirm()">
  <div>
    <div class="center big-padding">
      Souhaitez-vous supprimer cette collecte ?
    </div>

    <div class="form-group">
      <label for="objetDemande">
        Numero
      </label>
      <textarea type="text" class="form-control" id="numCollecte" v-model="collecte.reference" disabled>
      </textarea>
    </div>
    <br>
    <br>
    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Confirmer la suppression
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
  </form>
</template>
<script>
export default {
  props: [
    'collecte',
  ],
  data: function () {
    return {
      texte: '',
    }
  },
  methods: {
    confirm: function () {
      console.log(this.collecte)
      this.$store.dispatch('deactivateContenant', this.collecte)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// CollecteDelete.vue?620b2386